<div class="topics-list">
  <app-loader *ngIf="!topicStructure" [text]="'learnset.create_steps.review_step.loading' | translate"></app-loader>
  <app-button-selection-group [multiSelection]="true" [options]="topics" [selectedOptions]="selectedTopics" (selectedOptionsChange)="handleSelectionChange($event)"></app-button-selection-group>
  
  <!--<ng-container *ngFor="let topic of topicStructure?.topics">
    <div class="topic" (click)="topic.expanded = !topic.expanded">
      <label class="topic-label" (click)="$event.stopPropagation()">
        <input type="checkbox" [(ngModel)]="topic.checked" (ngModelChange)="handleTopicSelectedChange(topic)" />
        <h2>{{ topic.topic }}</h2>
      </label>
      <i *ngIf="!topic.expanded" class="fas fa-caret-down"></i>
      <i *ngIf="topic.expanded" class="fas fa-caret-up"></i>
    </div>
    <ng-container *ngIf="topic.expanded">
      <ng-container *ngFor="let subtopic of topic.subtopics">
        <label class="subtopic-label">
          <input type="checkbox" [(ngModel)]="subtopic.checked" (ngModelChange)="handleSubtopicSelectedChange(topic, subtopic)" />
          <p>{{ subtopic.topic }}</p>
        </label>
      </ng-container>
    </ng-container>
  </ng-container>-->
</div>